import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { locale, t } from '@/i18n';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// "2026-10-05 13:21:01.660" (UTC from the API) -> local date/time text
export function fmtTime(v: unknown): string {
  if (v === null || v === undefined || v === '') return '';
  const d = new Date(String(v).replace(' ', 'T') + (String(v).endsWith('Z') ? '' : 'Z'));
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString(locale());
}

export function fmtDuration(sec: unknown): string {
  const s = Math.max(0, Math.round(Number(sec) || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}` : `${m}:${String(r).padStart(2, '0')}`;
}

export function pct(v: unknown): string {
  const n = Number(v);
  return Number.isFinite(n) ? `${(n * 100).toFixed(1)}%` : '';
}

// local datetime-input value -> "YYYY-MM-DDTHH:MM" in UTC for the API
export function toUtcParam(local: string): string {
  if (!local) return '';
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 16);
}

export function humanize(key: string): string {
  const k = key === 'list_ids' ? 'contact_lists' : key.endsWith('_ids') ? `${key.slice(0, -4)}s` : key.endsWith('_id') && key !== 'caller_id' ? key.slice(0, -3) : key;
  return k.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase()).replace(/^Sla /, 'SLA ').replace(/ pct$/, ' %');
}

// a field name from the API ("queue_id") as a translated label ("Queue" / "Cola")
export const fieldLabel = (key: string): string => t(humanize(key));
// an enum value from the API ("IN_CALL") as translated text ("IN CALL" / "EN LLAMADA")
export const enumLabel = (v: unknown): string => (v === null || v === undefined ? '' : t(String(v).replace(/_/g, ' ')));
